export default {
    namespaced: true,
    state: {
      step: 1,
      model: null,
      versendenNEZOPostfach: null,
      istAbweichendeAdresse: null,
      istGesiegelteBestaetigung: null,
      isVertretung: false,
      datenRichtigkeit: false,
      antragsbestaetigung: false,

    },
    getters: {
      isVertretung (state) {
        return state.isVertretung
      },
      istAbweichendeAdresse (state) {
        return state.istAbweichendeAdresse
      },
      istGesiegelteBestaetigung (state) {
        return state.istGesiegelteBestaetigung
      },
      versendenNEZOPostfach (state) {
        return state.versendenNEZOPostfach
      },
      datenRichtigkeit (state) {
        return state.datenRichtigkeit
      },
      antragsbestaetigung (state) {
        return state.antragsbestaetigung
      },

      step (state) {
        return state.step
      },
      model (state) {
        return state.model
      }
    },
    mutations: {
      reset (state) {
        state.loggedin = false
        state.vertretungsberechtigung = null
        state.versendenNEZOPostfach = null
        state.istAbweichendeAdresse = null
        state.ist3Stellige = null
        state.ist6Stellige = null
        state.istGesiegelteBestaetigung = null
        state.isVertretung = false
        state.datenRichtigkeit = false
        state.antragsbestaetigung = false
      },
      isVertretung (state, isVertretung) {
        state.isVertretung = isVertretung
      },
      istAbweichendeAdresse (state, istAbweichendeAdresse) {
        state.istAbweichendeAdresse = istAbweichendeAdresse
      },
      istGesiegelteBestaetigung (state, istGesiegelteBestaetigung) {
        state.istGesiegelteBestaetigung = istGesiegelteBestaetigung
      },
      versendenNEZOPostfach (state, versendenNEZOPostfach) {
        state.versendenNEZOPostfach = versendenNEZOPostfach
      },
      datenRichtigkeit (state, datenRichtigkeit) {
        state.datenRichtigkeit = datenRichtigkeit
      },
      antragsbestaetigung (state, antragsbestaetigung) {
        state.antragsbestaetigung = antragsbestaetigung
      },
      step (state, step) {
        state.step = step
      },
      increaseStep (state) {
        state.step++
      },
      decreaseStep (state) {
        state.step--
      },
      model (state, model) {
        state.model = model
      }
    },

}
